import { FC } from 'react';

import { BusinessHubFooterBottom } from './business-hub-footer-bottom';
import { BusinessHubFooterContactUs } from './business-hub-footer-contact-us/business-hub-footer-contact-us';
import { BusinessHubFooterTop } from './business-hub-footer-top';

import styles from './business-hub-footer.module.scss';

interface Props {
    theme?: 'light' | 'dark';
    showContactUsForm?: boolean;
    showSayHello?: boolean;
    showReadyToGrow?: boolean;
    footerLink?: string;
    page: any;
}

export const BusinessHubFooter: FC<Props> = ({ theme, footerLink, showContactUsForm, showSayHello = true, showReadyToGrow = true, page }) => {
    return (
        <div className={styles.container}>
            {showSayHello ? <BusinessHubFooterTop theme={theme} ctaLink={footerLink} page={page} /> : null}
            {showContactUsForm ? <BusinessHubFooterContactUs rounded={!showReadyToGrow} /> : null}
            {showReadyToGrow ? <BusinessHubFooterBottom ctaLink={footerLink} page={page} /> : null}
        </div>
    );
};
